import { hasAnyRole, ROLE_NAMES } from "../../Helpers/roles";
import { getViewPackPermissions } from "./viewPackPermissions";

const PACK_MANAGER_ROLES = [ROLE_NAMES.SUPER_ADMIN, ROLE_NAMES.PLANNER];

export const canManagePackRegister = (user) => hasAnyRole(user, PACK_MANAGER_ROLES);

export const canEditPack = (user, pack) => getViewPackPermissions(user, pack).canEdit;

export const canDuplicatePack = (user, pack) => getViewPackPermissions(user, pack).canDuplicate;

export const canVoidPack = (user, pack) => getViewPackPermissions(user, pack).canVoid;

export const canExportPackRegister = (user) => canManagePackRegister(user);
